<template>
    <div class="xiangmu">
        <Breadtabsheader/>
        <div class="h-piece h-mrt30">
            <div class="h-formBox">
                <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
                    <div class="h-thirdColumn w-newColumn">
                        <el-form-item label="年份">
                            <el-select v-model="q.yearStr"  placeholder="请选择" clearable>
                                <el-option label="2020" value="2020"></el-option>
                                <el-option label="2021" value="2021"></el-option>
                                <el-option label="2022" value="2022"></el-option>
                                <el-option label="2023" value="2023"></el-option>
                                <el-option label="2024" value="2024"></el-option>
                                <el-option label="2025" value="2025"></el-option>
                                <el-option label="2026" value="2026"></el-option>
                                <el-option label="2027" value="2027"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="季度">
                            <el-select v-model="q.quarterStr" :clearable="true"
                                       placeholder="请选择">
                                <el-option label="第一季度" value="1"></el-option>
                                <el-option label="第二季度" value="2"></el-option>
                                <el-option label="第三季度" value="3"></el-option>
                                <el-option label="第四季度" value="4"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="销售区域">
                            <brselectlazy category="YlSalesArea_chanpin" :v="q.salesregionSell"
                                          v-model="q.salesregionSell" :clearable="true"/>
                        </el-form-item>
                        <el-form-item label="公司编码或名称">
                            <el-input v-model="q.userCodeOrNmae" placeholder=""></el-input>
                         </el-form-item>

                    </div>
                </el-form>
                <div class="l-screenBox">
                    <div class="l-retrieval">
                        <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
                        <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="h-table h-mrt30">
            <el-table
                ref="multipleTable"
                @selection-change="handleSelectionChange"
                :data="tableData2"
                style="width: 100%"
                :border="true"
                max-height="440"
            >
                <el-table-column
                    type="selection"
                    width="45"
                    :label="all"
                >
                </el-table-column>
                <el-table-column
                    fixed
                    type="index"
                    label="#"
                    width="40">
                </el-table-column>

                <el-table-column
                    prop="userCode"
                    label="用户编码"
                    width="100"
                    fixed
                >
                </el-table-column>
                <el-table-column
                    prop="userName"
                    label="用户名称"
                    width="200"
                    fixed
                >
                </el-table-column>
                <el-table-column
                    prop="salesregionSell"
                    label="销售区域"
                    :show-overflow-tooltip="true"
                    align="center"
                    width="100">
                    <template slot-scope="scope">
                        {{scope.row.salesregionSell | dictname('YlSalesArea_chanpin')}}
                    </template>
                </el-table-column>
                <el-table-column
                    prop="grade"
                    label="等级"
                    width="80"
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    prop="allScore"
                    label="总得分"
                    width="80"
                    :show-overflow-tooltip="true"
                >
                </el-table-column>

                <el-table-column label="销售收入能力(50)" :show-overflow-tooltip="true">
                    <el-table-column
                        prop="xsscore"
                        label="得分"
                        width="80"
                        :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column
                        prop="xsquarterL"
                        label="季度履约率"
                        width="80"
                        :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column
                        prop="xsyearL"
                        label="当年累计履约率"
                        width="80"
                        :show-overflow-tooltip="true">
                    </el-table-column>

                    <el-table-column
                        prop="xsachieveNum"
                        label="履约率达标个数"
                        width="80"
                        :show-overflow-tooltip="true">
                    </el-table-column>
                </el-table-column>

                <el-table-column label="抓关键用户能力(10)" :show-overflow-tooltip="true">
                    <el-table-column
                        prop="gjscore"
                        label="得分"
                        width="80"
                        :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column
                        prop="gjtopUserCoverage"
                        label="TOP用户覆盖率"
                        width="80"
                        :show-overflow-tooltip="true">
                    </el-table-column>
<!--                    <el-table-column
                        prop="gjallNum"
                        label="经销商对阵用户数"
                        width="80"
                        :show-overflow-tooltip="true">
                    </el-table-column>-->
                    <el-table-column
                        prop="gjnoZero"
                        label="top已覆盖个数"
                        width="80"
                        :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column
                        prop="gjallTop"
                        label="top签约个数"
                        width="80"
                        :show-overflow-tooltip="true">
                    </el-table-column>
                </el-table-column>

                <el-table-column label="新品突破能力(5)" :show-overflow-tooltip="true">

                    <el-table-column
                        prop="xpscore"
                        label="得分"
                        width="80"
                        :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column
                        prop="xpperformance"
                        label="新品履约率"
                        width="80"
                        :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column
                        prop="xpquarterS"
                        label="季度销额"
                        width="80"
                        :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column
                        prop="xpquarterM"
                        label="季度目标"
                        width="80"
                        :show-overflow-tooltip="true">
                    </el-table-column>
                </el-table-column>

                <el-table-column label="专业团队能力(5)" :show-overflow-tooltip="true">
                    <el-table-column
                        prop="zyscore"
                        label="得分"
                        width="80"
                        :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column
                        prop="zypnumDecimal"
                        label="销售人员个数"
                        width="80"
                        :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column
                        prop="zycontractAmount"
                        label="年度签约额（百万）"
                        width="80"
                        :show-overflow-tooltip="true">
                    </el-table-column>
                </el-table-column>

                <el-table-column label="分销商平台能力(10)" :show-overflow-tooltip="true">
                    <el-table-column
                        prop="fxscore"
                        label="得分"
                        width="80"
                        :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column
                        prop="fxuserValidCount"
                        label="成单分销商个数"
                        width="80"
                        :show-overflow-tooltip="true">
                    </el-table-column>
                </el-table-column>
                <el-table-column label="抓场景方案能力(10)" :show-overflow-tooltip="true">
                    <el-table-column
                        prop="cjscore"
                        label="得分"
                        width="80"
                        :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column
                        prop="cjsceneCount"
                        label="场景方案订单数量"
                        width="80"
                        :show-overflow-tooltip="true">
                    </el-table-column>
                </el-table-column>

                <el-table-column label="漏斗转化能力(10)" :show-overflow-tooltip="true">
                    <el-table-column
                        prop="ldscore"
                        label="得分"
                        width="80"
                        :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column
                        prop="ldevenCount"
                        label="已转化数量"
                        width="80"
                        :show-overflow-tooltip="true">
                    </el-table-column>

                    <el-table-column
                        prop="ldallCount"
                        label="总数量"
                        width="80"
                        :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column
                        prop="ldfunnelConversion"
                        label="漏斗转化率"
                        width="80"
                        :show-overflow-tooltip="true">
                    </el-table-column>
                </el-table-column>

            </el-table>
            <div class="h-tableB h-mrt30">
                <div class="h-tableBL">
                    <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                               style="margin-left:-20px;" @click="exportExcel">批量导出
                    </el-button>
                </div>


                    <pagination :page="q" @query="query"/>

            </div>
        </div>

    </div>
</template>
<script>
import ss from '../../api/SystemService'
import http from "@/utils/fetch";
import updownfile from "@/utils/updownfile";

export default {
    name: "productManage",
    data() {
        return {
            // 展开折叠筛选
            isScreen: false,

            status: 1,


            q: {
                ids: [],
                yearStr: '',
                quarterStr:'',
                userCodeOrNmae:'',
                salesregionSell:'',
                pageSize: 10,
                pageNo: 1,
                total: 0
            },
            wuliaozu: [],
            chanpindalei: [],
            //表单
            all: '全部',
            //表格
            multipleSelection: [],
            tableData2: []
        }
    },

    //加载页面默认执行
    created() {

        this.query();
    },

    //监听
    watch: {},

    methods: {

        resetData() {

            this.q.yearStr = null;
            this.q.quarterStr = null;
            this.q.userCodeOrNmae =null;
            this.q.pageSize = 10;
            this.q.pageNo = 1;

        },

        handleCurrentChange() {

        },
        handleSizeChange() {

        },


        //查询翻页
        query() {
            this.q.ids = [];

            ss.noticeBoard.getUserSalesAbilityPage(this.q).then(rd => {
                console.log('看看走没走查询', rd.records)
                this.q.total = rd.total;
                this.tableData2 = rd.records;

            })
        },

        handleFilter() {
            this.q.pageNo = 1;
            this.query();
        },
        handleSelectionChange(val) {
            console.log(val)
            this.multipleSelection = val;
        },


        //导表
        exportExcel() {

            this.q.ids=  _.join(_.map(this.multipleSelection,"id"),",");

            updownfile.down("/api/swyl/v1/board/userMapAndScore/downloadExcel", this.q, "get", 'params');
        },

    },
    mounted() {

    },
}
</script>
<style scoped>
.xiangmu > .h-piece, .h-mrt30 {
    margin: 20px;
}

.h-formBtnOut .h-mr20 {
    margin-left: 3rem !important;
}
</style>
<style scoped lang="scss">
.bottomTip {
    position: absolute;
    left: 49.7%;
    bottom: 0.3rem;
    transform: translateX(-50%);
}

.newtext {
    font-size: 0.28rem;
    color: white;
    position: absolute;
    top: 0.2rem;
    left: 50%;
    transform: translateX(-50%);
    font-weight: bold;
    text-shadow: 1px 1px 4px #2785E7;
    z-index: 2;
}

.leaderBox {
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
    position: fixed;
    z-index: 99999;
    overflow: hidden;
    top: 0;
    left: 0;

    .leaderbg {
        width: 100%;
        height: 100%;
    }

    .steps {
        position: absolute;
        z-index: 1;
    }

    .step1 {
        top: 2.3rem;
        left: 8.25rem;
        width: 2.1rem;
        height: 1.8rem;
    }

    .step2 {
        top: 3.05rem;
        right: 1.1rem;
        width: 2.8rem;
        height: 1.9rem;
    }

    .step3 {
        top: 4.2rem;
        left: 2.7rem;
        width: 13.5rem;
        height: 2rem;
    }

    .step4 {
        top: 6.2rem;
        left: 11rem;
        width: 2rem;
        height: 1.5rem;
    }

    .stepbtn {
        width: 1.9rem;
        height: 0.6rem;
        border: 0.03rem solid #FFFFFF;
        background-color: rgba(0, 0, 0, 0.1);
        border-radius: 5px;
        display: flex;
        justify-content: center;
        line-height: 0.5rem;
        position: absolute;
        z-index: 99;
        bottom: 0.65rem;
        left: 50%;
        transform: translateX(-50%);
        font-size: 0.27rem;
        letter-spacing: 2px;
        color: white;
        cursor: pointer;
    }

    .closeIt {
        width: 0.3rem;
        height: 0.3rem;
        position: absolute;
        top: 0.2rem;
        right: 0.2rem;
        cursor: pointer;
    }
}
</style>
